(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kulckan-producto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kulckan-product')) {
    customElements.define('kulckan-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const main = this.querySelector('.gallery-main');
        const dialog = this.querySelector('dialog');
        this.addEventListener('click', (event) => {
          const photo = event.target.closest('[data-photo]');
          if (photo && main) {
            main.removeAttribute('srcset');
            main.src = photo.dataset.photo;
            main.alt = photo.dataset.alt;
            this.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
          }
          if (event.target.closest('[data-zoom]') && main) {
            const copy = main.cloneNode();
            copy.removeAttribute('class');
            dialog.querySelector('.dialog-body').replaceChildren(copy);
            dialog.showModal();
          }
          if (event.target.closest('[data-close]')) dialog.close();
        });
        this.querySelector('[data-variant]')?.addEventListener('change', (event) => {
          const option = event.target.selectedOptions[0];
          this.querySelector('.price').textContent = option.dataset.price;
          const buy = this.querySelector('[data-buy]');
          buy.disabled = option.dataset.available !== 'true' || buy.dataset.enabled !== 'true';
          buy.textContent = buy.disabled ? buy.dataset.unavailableLabel : buy.dataset.addLabel;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
